const StickyHeader = {
	targetTime: null,
  countdownRoot: null,

  init() {
    const header = document.querySelector(".top-nav");
    let lastScrollY = window.scrollY;

    function isMobile() {
      return window.matchMedia("(max-width: 1025px)").matches;
    }    

    window.addEventListener("scroll", function () {
      if (!isMobile()) {
        header.style.transform = "translateY(0)";
        return;
      }

      const currentScrollY = window.scrollY;
      if (currentScrollY <= 200) {
        header.style.transform = "translateY(0)";
        header.classList.add("sticky");
      } else if (currentScrollY < lastScrollY) {
        header.style.transform = "translateY(0)";
        header.classList.add("sticky");
      } else if (currentScrollY > lastScrollY) {
        header.style.transform = "translateY(-100%)";
        header.classList.add("sticky");
      }

      lastScrollY = currentScrollY;
    });

    if(isMobile()){
      this.countdownRoot = document.querySelector(".countdown-banner-mobile")
    } else {
      this.countdownRoot = document.querySelector(".header__countdown-banner")
    }

    if(!this.countdownRoot){
      return
    }

    this.targetTime =
      this.countdownRoot.querySelector("#headerCountdown")?.dataset.target;
    if (this.targetTime) {
      this.startCountdown(this.targetTime);
    } else {
      this.destroyCountdown()
    }
  },

  getCountdownComponents(unixTimestamp) {
    const now = Math.floor(Date.now() / 1000);
    let diff = unixTimestamp - now;

    if (diff <= 0) {
      this.destroyCountdown
      // return null;
    }

    const days = Math.floor(diff / (60 * 60 * 24));
    diff %= 60 * 60 * 24;

    const hours = Math.floor(diff / (60 * 60));
    diff %= 60 * 60;

    const minutes = Math.floor(diff / 60);
    const seconds = diff % 60;

    return { days, hours, minutes, seconds };
  },

  startCountdown() {
    let cdInterval
    const update = ( countdown ) => {
      if( countdown.seconds < 0 ){
        clearInterval( cdInterval )
        this.destroyCountdown()
        return
      }
      this.countdownRoot.querySelector("#hcdDays").textContent = countdown.days;
      this.countdownRoot.querySelector("#hcdHours").textContent = countdown.hours;
      this.countdownRoot.querySelector("#hcdMinutes").textContent = countdown.minutes;
      this.countdownRoot.querySelector("#hcdSeconds").textContent = countdown.seconds;
    };

    update( this.getCountdownComponents(this.targetTime) );
    cdInterval = setInterval(() => { update( this.getCountdownComponents(this.targetTime) ) }, 1000);
  },

  destroyCountdown() {
    if ( this.countdownRoot ){
     this.countdownRoot.remove()
    }
  }
};

export default StickyHeader;
